import { ChangedPath } from 'ag-grid-community';
import { IToken } from '../types/my-types';

const arraysEqual = (a: IToken[], b: IToken[]) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export default function canSubmitCorrection(
  initialValue: string | null,
  newValue: string,
  oldTokens: IToken[],
  newTokens: IToken[]
) {
  // If the initValue is null (blank field) and the value is an empty string, do not submit a correction
  if (initialValue === null && newValue === '') {
    return false;
  }

  // Only generate a correction if the tokens and value have changed. This is a fix to an issue where
  // the user was generating corrections by just hitting the enter key to go from field to field.
  if (initialValue !== newValue || !arraysEqual(oldTokens, newTokens)) {
    return true;
  }

  // no correction submitted
  return false;
}
